// Matches the prototype's `.mcp-uavatar` with its `ICON.user` glyph
// (subscription-portal.html `initUserLimits`): a 38px accent-subtle circle
// holding an 18px stroke-outline person in the accent text colour, the same
// for every user — the row's identity is its email, beside it (§16h), so the
// avatar carries no initials (MS-822).
//
// `size="sm"` is Settings › Access's `.access-avatar.access-avatar-user`
// (MS-997): a 30px circle with a 15px glyph, same colours.
const SIZES = {
  md: { box: 'w-[38px] h-[38px] min-w-[38px]', glyph: 18 },
  sm: { box: 'w-[30px] h-[30px] min-w-[30px]', glyph: 15 },
} as const

export function Avatar({
  className = '',
  size = 'md',
}: Readonly<{ className?: string; size?: keyof typeof SIZES }>) {
  const { box, glyph } = SIZES[size]
  return (
    <div
      aria-hidden="true"
      data-testid="avatar"
      className={`${box} rounded-full bg-[var(--accent-subtle)] text-[var(--accent-text)] flex items-center justify-center shrink-0 ${className}`}
    >
      <svg
        viewBox="0 0 24 24"
        width={glyph}
        height={glyph}
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
      </svg>
    </div>
  )
}
